import { useEffect, useRef } from "react";
import { useInstantSearch } from "react-instantsearch";

export const useRefreshAlgoliaData = () => {
  const { refresh } = useInstantSearch();
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const refreshAlgoliaData = (timeout = 3000) => {
    timerRef.current = setTimeout(() => {
      refresh();
    }, timeout);
  };

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return {
    refreshAlgoliaData,
  };
};
